import { render, staticRenderFns } from "./AdminMatchesListView.vue?vue&type=template&id=52492a27&scoped=true"
import script from "./AdminMatchesListView.vue?vue&type=script&lang=js"
export * from "./AdminMatchesListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52492a27",
  null
  
)

export default component.exports